<template>
  <ContentFrame
  :themeColor="computedTopicColor"
  :title="computedTitle"
  >
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c1.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c1.t1.title')"
        :subtitle="$t('projects.c1.t1.subtitle')"
        :textArray="[$t('projects.c1.t1.p0'), $t('projects.c1.t1.p1')]"
      />
      <ContentImageTile
        embedded
        imageSource="/img/projekte/denkmal_kalender/Weltgefaehrdung_JSchreiter_FotoMKesslerUlm.jpg"
        :caption="$t('projects.c1.img.caption')"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c1.t2.title')"
        :textArray="[$t('projects.c1.t2.p0')]"
        :downloadText="$t('projects.c1.t2.download')"
        downloadFileName="denkmal-aktiv-kalender.pdf"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c2.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c2.t1.title')"
        :subtitle="$t('projects.c2.t1.subtitle')"
        :textArray="[$t('projects.c2.t1.p0'), $t('projects.c2.t1.p1')]"
      />
      <ContentVideoTile
        embedded
        :title="$t('projects.c2.video.title')"
        videoSource='/vid/skulptur_interview.m4v'
        videoType='video/mp4'
      />
      <ContentGalleryTile
        embedded
        v-if="photosSculpture.length > 0"
        :themeColor="computedTopicColor"
        :title="$t('projects.c2.gallery.title')"
        :photos="photosSculpture"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c3.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c3.t1.title')"
        :textArray="[$t('projects.c3.t1.p0'), $t('projects.c3.t1.p1'), $t('projects.c3.t1.p2')]"
      />
      <ContentVideoTile
        embedded
        videoSource='/vid/Hans-Lebrecht-Schule_Film-Tag-auf-Jugendstation.mp4'
        posterSource='/img/projekte/tag_auf_jugendstation/thumbnail.jpg'
        videoType='video/mp4'
      />
      <ContentGalleryTile
        embedded
        v-if="photosJugendstation.length > 0"
        :themeColor="computedTopicColor"
        :title="$t('projects.c3.gallery.title')"
        :photos="photosJugendstation"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c4.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c4.t1.title')"
        :textArray="[$t('projects.c4.t1.p0'), $t('projects.c4.t1.p1'), $t('projects.c4.t1.p2')]"
      />
      <ContentImageTile
        embedded
        imageSource="/img/projekte/bedeutsames_in_ulm/cover.jpg"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c4.t2.title')"
        :textArray="[$t('projects.c4.t2.p0')]"
        :downloadText="$t('projects.c4.t2.download')"
        downloadFileName="Hans-Lebrecht-Schule_BiU.pdf"
      >
        <v-col
          slot="content"
          v-if="emailRequestAddress"
          cols="12"
          class="py-2"
        >
          <ContactChip
            icon="mdi-email"
            :value="emailRequestAddress"
            :href="'mailto:' + emailRequestAddress + '?subject=' + emailRequestSubjectBiU"
          />
        </v-col>
      </ContentTile>
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c5.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c5.t1.title')"
        :textArray="[$t('projects.c5.t1.p0'), $t('projects.c5.t1.p1')]"
      />
      <ContentImageTile
        embedded
        imageSource="/img/projekte/dazugehoeren/cover.jpg"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c5.t2.title')"
        :textArray="[$t('projects.c5.t2.p0')]"
        :downloadText="$t('projects.c5.t2.download')"
        downloadFileName="Hans-Lebrecht-Schule_D.pdf"
      >
        <v-col
          slot="content"
          v-if="emailRequestAddress"
          cols="12"
          class="py-2"
        >
          <ContactChip
            icon="mdi-email"
            :value="emailRequestAddress"
            :href="'mailto:' + emailRequestAddress + '?subject=' + emailRequestSubjectD"
          />
        </v-col>
      </ContentTile>
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('projects.c6.title')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('projects.c6.t1.title')"
        :textArray="[$t('projects.c6.t1.p0'), $t('projects.c6.t1.p1'), $t('projects.c6.t1.p2'), $t('projects.c6.t1.p3')]"
        :downloadText="$t('projects.c6.t1.download')"
        downloadFileName="Hans-Lebrecht-Schule_DakSs.pdf"
      />
      <ContentImageTile
        embedded
        imageSource="/img/projekte/das_alles_kann_schule_sein/cover.jpg"
      />
    </ContentContainer>
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentContainer from '@/views/components/ContentContainer.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentVideoTile from '@/views/components/ContentVideoTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ContentGalleryTile from '@/views/components/ContentGalleryTile.vue'
import ContactChip from '@/views/components/ContactChip.vue'

export default {
  name: 'Projects',
  components: {
    ContentContainer,
    ContentFrame,
    ContentTile,
    ContentVideoTile,
    ContentImageTile,
    ContentGalleryTile,
    ContactChip
  },
  data () {
    return {
      emailRequestAddress: 'info@hans-lebrecht-schule.de',
      emailRequestSubjectBiU: 'Buch Bedeutsames in Ulm',
      emailRequestSubjectD: 'Buch dazugehoeren',
      photosSculpture: [
        {
          src: '/img/projekte/skulpturen/01.jfif',
          description: 'Erste Entwürfe der Schüler*innen zur Skulptur in Form von Zeichnungen oder Skizzen sowie Modellen'
        },
        {
          src: '/img/projekte/skulpturen/02.jfif',
          description: 'Erste Entwürfe der Schüler*innen zur Skulptur in Form von Zeichnungen oder Skizzen sowie Modellen'
        },
        {
          src: '/img/projekte/skulpturen/03.jpg',
          description: 'Erste Entwürfe der Schüler*innen zur Skulptur in Form von Zeichnungen oder Skizzen sowie Modellen'
        },
        {
          src: '/img/projekte/skulpturen/04.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/05.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/06.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/07.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/08.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/09.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/10.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/11.jpg',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/12.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/13.jpg',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/14.jpg',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/15.jpg',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/16.jpg',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/17.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/18.jfif',
          description: 'Entstehungsprozess der Skulpturen'
        },
        {
          src: '/img/projekte/skulpturen/19.jpg',
          description: 'Musikalische Einlage von Thorsten Sukale und Band'
        },
        {
          src: '/img/projekte/skulpturen/20.jpg',
          description: 'Schild zur Skulptur'
        },
        {
          src: '/img/projekte/skulpturen/21.jpg',
          description: 'Skulptur zum Thema "Dazugehören"'
        }
      ],
      photosJugendstation: [
        { src: '/img/projekte/tag_auf_jugendstation/01.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/02.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/03.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/04.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/05.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/06.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/07.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/08.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/09.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/10.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/11.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/12.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/13.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/14.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/15.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/16.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/17.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/18.jpg', description: null },
        { src: '/img/projekte/tag_auf_jugendstation/19.jpg', description: null }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.projects.color
    },
    computedTitle () {
      return this.menuData.projects.title
    }
  }
}
</script>

<style scoped>
</style>
